"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemVariants = exports.itemTransition = exports.ImageUpload = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _framerMotion = require("framer-motion");
var _react = require("react");
var _hooks = require("../../hooks");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const itemVariants = exports.itemVariants = {
  exit: {
    opacity: 0,
    scale: 0.8
  }
};
const itemTransition = exports.itemTransition = {
  layout: {
    type: 'spring',
    stiffness: 300,
    damping: 30
  },
  opacity: {
    duration: 0.2
  },
  scale: {
    duration: 0.2
  }
};
const ImageUpload = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    open,
    onToggle
  } = (0, _presentationHooks.useDisclose)();
  const inputRef = (0, _react.useRef)(null);
  const onAddPhotoClick = (0, _react.useCallback)(() => {
    inputRef.current?.click();
  }, []);
  const onFilesChange = (0, _react.useCallback)(e => {
    const {
      files
    } = e.target;
    if (files == null) {
      return;
    }
    const fileList = [...files];
    // TODO: Upload photos when API is ready
    void fileList;
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
    "data-testid": getTestId(_constants.IMAGE_UPLOAD),
    display: "flex",
    flexDirection: "column",
    gap: 1,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      display: "flex",
      gap: 1,
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        ref: inputRef,
        multiple: true,
        hidden: true,
        "data-testid": getTestId(_constants.IMAGE_UPLOAD_INPUT),
        type: "file",
        accept: "image/*",
        "aria-label": translations.addPhoto,
        onChange: onFilesChange
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        "data-testid": getTestId(_constants.ADD_PHOTO),
        variant: "text",
        size: "small",
        startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CameraFilled, {}),
        onClick: onAddPhotoClick,
        children: translations.addPhoto
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        disableUppercase: true,
        "data-testid": getTestId(_constants.SHOW_RULES_AND_GUIDELINES),
        variant: "text",
        size: "small",
        onClick: onToggle,
        children: translations.showRulesAndGuidelines
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_framerMotion.AnimatePresence, {
      mode: "popLayout",
      children: open ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_framerMotion.motion.div, {
        layout: true,
        ..._constants.MOTION_DIV_PROPS,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextWithHtml, {
          html: translations.rulesAndGuidelines
        })
      }) : null
    })]
  });
};
exports.ImageUpload = ImageUpload;
